import { maxLengthRule, requiredRule } from './main.js';
import { fio } from '@/common/validators.js';
import { helpers } from '@vuelidate/validators';

export function fioRulesDefault() {
    return {
        fio: helpers.withMessage('Введите ФИО русскими буквами (от 2 до 5 слов). Допускается ввод через дефис', fio),
        ...requiredRule(),
        ...maxLengthRule(),
    };
}
